import { ShehiaContent } from "../../components/boundary"

export default function Shehia () {

  return (

    <>
        <ShehiaContent/>
    </>

  )

}